<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Reporte, consolidado de ventas, compras, pagos, etc.
    </h2>
    <MainConsolidatedSales />
  </div>
</template>

<script>
import MainConsolidatedSales from "@/components/Reports/ConsolidatedSales/MainConsolidatedSales.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ConsolidatedSales",
  components: {
    MainConsolidatedSales,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
